import { formatAsQuantity } from 'common/source/utilities/strings';

const ROOF_TYPE = {
    asphalt_fiberglass_shingles: 'Asphalt / fiberglass shingles',
    architectural_shingles: 'Architectural shingles',
    clay_tile: 'Clay tile',
    wood_shingle_or_shake: 'Wood shingle or shake',
    flat_roof: 'Flat roof of any kind',
    concrete_tile: 'Concrete tile',
    slate_tile: 'Slate tile',
    steel_or_metal: 'Steel or metal',
    other: 'Other'
};

const CONSTRUCTION_TYPE = {
    frame: 'Frame',
    brick_veneer: 'Brick veneer',
    masonry: 'Masonry',
    concrete: 'Concrete',
    steel: 'Steel'
};

export class PropertyDataDisplay {
    private propertyData: PropertyData;

    constructor(propertyData: PropertyData) {
        this.propertyData = propertyData;
    }

    getYearBuilt() {
        return this.propertyData.year_built;
    }

    getSquareFootage() {
        if (this.propertyData.square_footage !== undefined) {
            return formatAsQuantity(this.propertyData.square_footage);
        }
    }

    getRoofType() {
        const roofType = this.propertyData.roof_type;

        if (roofType !== undefined) {
            if (roofType in ROOF_TYPE) {
                return ROOF_TYPE[roofType as keyof typeof ROOF_TYPE];
            } else {
                // TODO: silently send an error report, this shouldn't happen
                return 'Other';
            }
        }
    }

    getRoofConstructedOrReplacedYear() {
        return this.propertyData.year_roof_built;
    }

    getNumberOfFamilyUnits() {
        const families = this.propertyData.number_of_family_units;

        if (families !== undefined) {
            if (families === '1') {
                return 'Single family';
            } else {
                return `${families} families`;
            }
        }
    }

    getNumberOfStories() {
        return this.propertyData.number_of_stories;
    }

    hasSwimmingPool() {
        if (this.propertyData.swimming_pool !== undefined) {
            return this.propertyData.swimming_pool ? 'Yes' : 'No';
        }
    }

    getConstructionType() {
        if (this.propertyData.construction_type !== undefined) {
            return CONSTRUCTION_TYPE[this.propertyData.construction_type];
        }
    }

    getTrampoline() {
        if (this.propertyData.trampoline !== undefined) {
            return this.propertyData.trampoline ? 'Yes' : 'No';
        }
    }
}
